export default __webpack_public_path__ + "fd6e48a4516c437fe069da73ba6164be.jpg";